import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Box, Badge } from "@mui/material";
import { useTheme } from "../style/theme";
import { PenTool, Layout, Grid, MessageSquare } from "lucide-react";
import ActiveAppsIcon from "../services/icons/active-menu/apps.svg";
import AppsIcon from "../services/icons/menu/apps.svg";
import { LayoutTemplate, PenLine, FileText } from "lucide-react";
import SignIcon from "../style/icons/icon-sign.png";
import DocIcon from "../style/icons/icon-doc.png";
import TempIcon from "../style/icons/icon-template.png";
import OverviewIcon from "../style/icons/overview-icon.png";
import { PiChatTeardropText } from "react-icons/pi";
import { Image } from "@mui/icons-material";

const Footer = () => {
  const theme = useTheme();
  const [activeIcon, setActiveIcon] = useState("");
  const location = useLocation();

  const handleIconClick = (iconName) => {
    setActiveIcon(iconName === activeIcon ? null : iconName);
  };

  const Apps = ({ active }) => (
    <img
      src={active ? ActiveAppsIcon : AppsIcon}
      alt="Interview Icon"
      style={{ width: "20px", height: "20px" }}
    />
  );

  return (
    <Box
      sx={{
        backgroundColor: theme.mode === "dark" ? "#141414" : "#FFFFFF",
        color: theme.mode === "dark" ? "#FFFFFF" : "#000000",
        height: "82px",
      }}
      className="fixed bottom-0 text-gray-500 w-full text-[10px] px-2 flex flex-row gap-4 items-center justify-between md:hidden right-0 left-0 z-[100]"
    >
      <NavLink to="/">
        {({ isActive }) => (
          <div
            className="flex flex-col items-center justify-center"
            onClick={() => handleIconClick("sign")}
          >
            <div
              style={{
                // padding: "2px 8px",
                // backgroundColor: isActive ? "#121d27" : "",
                color: isActive ? "#fff" : "",
                width: "40px",
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className={`p-1 rounded-xl ${
                theme.mode === "dark" ? "bg-[#181818]" : "bg-neutral-200"
              }`}
            >
              <img
                src={SignIcon}
                alt="Sign"
                className="w-7 h-7"
                style={{
                  filter: isActive
                    ? "brightness(0) saturate(100%) invert(44%) sepia(98%) saturate(1548%) hue-rotate(187deg) brightness(101%) contrast(101%)"
                    : "none",
                }}
              />
            </div>
            <p className={`${isActive && "text-[#0080ff]"} text-[10px]`}>
              Sign
            </p>
          </div>
        )}
      </NavLink>

      <NavLink to="https://chat.clikkle.com/">
        {({ isActive }) => (
          <div
            className="flex flex-col items-center justify-center"
            onClick={() => handleIconClick("overview")}
          >
            <div
              style={{
                // padding: "6px 12px",
                // backgroundColor: isActive ? "#121d27" : "",
                color: isActive ? "#fff" : "",
                width: "40px",
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className={`p-1 rounded-xl ${
                theme.mode === "dark" ? "bg-[#181818]" : "bg-neutral-200"
              }`}
            >
              <PiChatTeardropText
                size={"35px"}
                style={{
                  width: "24px",
                  height: "24px",
                  color: "gray",
                }}
              />
            </div>
            <p className={`${isActive && "text-[#0080ff]"} text-[10px]`}>
              Chat
            </p>
          </div>
        )}
      </NavLink>

      <NavLink to="https://apps.clikkle.com/">
        {({ isActive }) => (
          <div
            className="flex flex-col items-center justify-center "
            onClick={() => handleIconClick("app")}
          >
            <div
              className={`${
                isActive &&
                "text-white rounded-3xl bg-blue-500/[.15] w-[90%] flex justify-center "
              } px-2 py-1`}
            >
              <Apps active={isActive} size={"20px"} />
            </div>
          </div>
        )}
      </NavLink>

      <NavLink to="/documents">
        {({ isActive }) => (
          <div
            className="flex flex-col items-center justify-center"
            onClick={() => handleIconClick("document")}
          >
            <div
              style={{
                // padding: "4px 12px",
                // backgroundColor: isActive ? "#121d27" : "",
                color: isActive ? "#fff" : "",
                width: "40px",
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className={`p-1 rounded-xl ${
                theme.mode === "dark" ? "bg-[#181818]" : "bg-neutral-200"
              }`}
            >
              <img
                src={DocIcon}
                alt="Template"
                className="w-6 h-6"
                style={{
                  filter: isActive
                    ? "brightness(0) saturate(100%) invert(44%) sepia(98%) saturate(1548%) hue-rotate(187deg) brightness(101%) contrast(101%)"
                    : "none",
                }}
              />
            </div>
            <p className={`${isActive && "text-[#0080ff]"} text-[10px]`}>
              Document
            </p>
          </div>
        )}
      </NavLink>

      <NavLink to="/templates">
        {({ isActive }) => (
          <div
            className="flex flex-col items-center justify-center"
            onClick={() => handleIconClick("template")}
          >
            <div
              style={{
                // padding: "4px 12px",
                // backgroundColor: isActive ? "#121d27" : "",
                color: isActive ? "#fff" : "",
                width: "40px",
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className={`p-1 rounded-xl ${
                theme.mode === "dark" ? "bg-[#181818]" : "bg-neutral-200"
              }`}
            >
              <img
                src={TempIcon}
                alt="Template"
                className="w-6 h-6"
                style={{
                  filter: isActive
                    ? "brightness(0) saturate(100%) invert(44%) sepia(98%) saturate(1548%) hue-rotate(187deg) brightness(101%) contrast(101%)"
                    : "none",
                }}
              />
            </div>
            <p className={`${isActive && "text-[#0080ff]"} text-[10px]`}>
              Template
            </p>
          </div>
        )}
      </NavLink>
    </Box>
  );
};

export default Footer;
